import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { initSentryIfEnabled } from './app/core/services/sentry.config';

initSentryIfEnabled();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
